import React from "react";
import { ComoUsar, LinkPrimary } from "../../../../components";
import AcionarSeguroDesktopImg from "../../../../assets/images/residencial/ilustracao-mulher-com-livro-desktop.svg";
import { links } from "../../../../config";

const AcionarSeguro = () => {
  return (
    <ComoUsar
      imgSrc={AcionarSeguroDesktopImg}
      imgAlt="Mulher com livro"
      title="Quer acionar seu seguro?"
      description="Assistência Dia & Noite e Sinistros"
      textAux={
        <>
          Baixe a{" "}
          <LinkPrimary target="_blank" href={links.residencial.cartilhaSeguro}>
            cartilha
          </LinkPrimary>{" "}
          para entender o que o seguro cobre ou ligue:
        </>
      }
      telefone="0800 274 1000"
    />
  );
};

export default AcionarSeguro;
